interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages: (number | string)[] = [];
  const push = (value: number | string) => pages.push(value);

  if (totalPages <= 7) {
    for (let index = 1; index <= totalPages; index += 1) push(index);
  } else if (page <= 4) {
    for (let index = 1; index <= 5; index += 1) push(index);
    push('ellipsis-end');
    push(totalPages);
  } else if (page >= totalPages - 3) {
    push(1);
    push('ellipsis-start');
    for (let index = totalPages - 4; index <= totalPages; index += 1) push(index);
  } else {
    push(1);
    push('ellipsis-start');
    push(page - 1);
    push(page);
    push(page + 1);
    push('ellipsis-end');
    push(totalPages);
  }

  return (
    <nav className="mt-10 flex flex-wrap items-center justify-center gap-1.5" aria-label="分页导航">
      <button
        type="button"
        onClick={() => onChange(page - 1)}
        disabled={page === 1}
        className="flex h-9 cursor-pointer items-center gap-1 rounded-md border border-background-200 bg-background-50 px-3 text-sm text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40"
      >
        <i className="ri-arrow-left-s-line" />
        上一页
      </button>

      {pages.map((item) =>
        typeof item === 'number' ? (
          <button
            key={item}
            type="button"
            onClick={() => onChange(item)}
            aria-current={item === page ? 'page' : undefined}
            className={`h-9 min-w-9 cursor-pointer rounded-md px-2 text-sm font-medium transition-colors ${
              item === page
                ? 'bg-primary-500 text-background-50'
                : 'border border-background-200 bg-background-50 text-foreground-600 hover:border-primary-300 hover:text-primary-600'
            }`}
          >
            {item}
          </button>
        ) : (
          <span key={item} className="flex h-9 w-7 items-center justify-center text-sm text-foreground-400">
            ···
          </span>
        ),
      )}

      <button
        type="button"
        onClick={() => onChange(page + 1)}
        disabled={page === totalPages}
        className="flex h-9 cursor-pointer items-center gap-1 rounded-md border border-background-200 bg-background-50 px-3 text-sm text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40"
      >
        下一页
        <i className="ri-arrow-right-s-line" />
      </button>
    </nav>
  );
}